import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getSeupplier = (cardname, _params, onSuccess, onError) => {
    const data = {
        cardname
    }
    const response = axios.post(`v1/admin/sap/supplier`, data, { params: _params });
    return handleResponse(response, onSuccess, onError);
}

export const sapSync = (itemCodes, onSuccess, onError) => {
    const data = {
        item_code: itemCodes
    }
    const response = axios.post(`v1/admin/sap/sync`, data);
    return handleResponse(response, onSuccess, onError);
}

